<template>
  <div class="list">
    <div v-for="(item, index) in formList" :key="index" class="list-item suggest-position" :class="[
         	{'date-time-link': (item.type === 'datetime' && sectionType === 'other') || (sectionType === 'project' && item.field === 'city')},
          {'honor-item': section === 'honor'}]" @click="handleClickSide(item)">
      <slot :name="`suggest-${item.adviceField || item.field}`"/>
      <div class="item-link">
        <div @click="changeLabel(other ? cv.submodule_info[`${item.field}_title`] : item.labelCn, item)">
          <span class="label">{{ other ? cv.submodule_info[`${item.field}_title`]  : item.labelCn }}</span>
          <span v-if="other" class="iconfont iconbianji"/>
        </div>
        <div :class="[{'search-input': item.search}, {'flex-between': other}]" @click="selectExtrasLabel(item)">
          <input type="text" v-model="other ? req[item.field].description : req[item.field]"
                 v-if="item.type === 'input'" :disabled="other || (companyNotClick && item.field === 'company')"
                 :placeholder="item.placeholderEn || item.placeholderCn" @input="inputChangeValue($event, item)">
          <div class="search-result" v-if="item.search && list[item.field].length">
            <cube-scroll :data="list[item.field]">
                <div v-for="(val, index) in list[item.field]" :key="index" class="search-item"
                     @click="selectLabel(item, val)" v-html="val.highlight"></div>
            </cube-scroll>
          </div>
          <span class="iconfont iconchevron-right" v-if="other"></span>
        </div>
<!--        学校 tag 选择-->
        <div class="tag-container" v-if="item.type === 'tag'">
          <div v-for="itemD in tags[lang]"
               :class="{'tag-item': true, 'active': (req.show_tags || []).includes(itemD.value)}"
               :key="itemD.value"
               @click="chooseTag(itemD)">
            {{ itemD.label }}
          </div>
        </div>
        <div>
          <input type="text" v-model="req[item.field]" v-if="item.typeEn === 'input' && lang === 'en'"
                 :placeholder="item.placeholderEn">
        </div>
        <div :class="req[item.field] ? 'title' : 'title w-placeholder'"
             v-if="item.type === 'picker' && (lang === 'cn' || eduSection)"
             @click="changePickerState(item)">
          {{ req[item.field] || item.placeholderCn }}
        </div>
        <div v-if="item.type === 'datetime'" class="flex-start">
          <div v-for="(val, index) in item.datePicker" :key="index" class="date-title"
               :class="[req[val.field] || (val.field === 'end_at' && req.present) ? 'title flex-start' : 'title flex-start w-placeholder', section === 'honor' ? 'honor-time-title' : '']"
               @click="changePickerState(val, index)">
            {{ timeShow(val) ? timeShow(val) : placeHolderType ? val.stuPlaceHolder : val.placeholderCn }}
          </div>
        </div>
      </div>
			<!-- <div class="search-result-mask" v-if="item.search && list[item.field].length" @click="handleClickSide(item)"></div> -->
    </div>
		<!-- 作品集二维码 -->
		<div class="list-item suggest-position" v-if="sectionType === 'opus'">
      <slot :name="`suggest-qrcode`"/>
      <div class="item-link" style="border-bottom: none">
        <div>
          <span class="label">上传图片 <span style="font-sizy:12px;color:#FF6644">*</span><span style="color:#9C9C9C">（线下投递 HR 可通过扫码查看作品集）</span></span>
        </div>
				<img :src="qrcode" alt="" class="qrcode-img" @click="selectQrcode" v-if="qrcode">
				<div class="qrcode-add iconfont iconcvs-chuangjian" v-else @click="selectQrcode"></div>
      </div>
			<!-- <div class="search-result-mask" v-if="item.search && list[item.field].length" @click="handleClickSide(item)"></div> -->
    </div>
		<input type="file" accept="image/*" ref="qrcodeUpInput" @change="fileChange" class="up-qrcode">

		<crop-picture :upFile="qrcode" ossLink="cv/opus" @qrcodeSubmit="qrcodeSubmit" v-if="showCropPicture" />
  </div>
</template>

<script>
	import { mapState } from 'vuex'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { envMixin } from '@/assets/js/mixin/global'
	import clickoutside from '@/assets/js/clickoutside'
	import cropPicture from '@/components/global/crop-picture'

	let moment = require('moment')
	export default {
		mixins: [ componentsMixin, envMixin ],
		props: {
			formList: {
				type: Array,
				default: () => []
			},
			req: {
				type: Object,
				default: () => {
					return {}
				}
			},
			sectionType: {
				type: String,
				default: 'other'
			},
			otherTitles: {
				type: Array,
				default: () => []
			},
			eduSection: {
				type: Boolean,
				default: false
			},
      companyNotClick:{
			  type: Boolean,
        default: false
      }
		},
		data () {
			return {
				field: '',
				multiple: false,
				multipleField: '',
				list: {
					company: [], // 公司
					university: [], // 学校
					major: [], // 专业
					city: [], // 城市
					uni_school: [], // 学院
					title: [] // 职位名称
				},
				qrcode: '', //作品集二维码
				showCropPicture: false, //显示裁剪图片
        tags: {
          en: [
            {
              label: '985',
              value: '985'
            },
            {
              label: '211',
              value: '211'
            },
            {
              label: 'Double 1st-Class',
              value: 'Double 1st-Class'
            },
            {
              label: 'QS Top100',
              value: 'QS Top100'
            }
          ],
          cn: [
            {
              label: '985',
              value: '985'
            },
            {
              label: '211',
              value: '211'
            },
            {
              label: '双一流',
              value: '双一流'
            },
            {
              label: '海外QS前100',
              value: '海外QS前100'
            }
          ]
        },     // tag 列表
        // show_tags: [],     // 选择的学校标签
			}
		},
		mounted () {
			this.qrcode = this.req.qrcode || ''
			console.log(1111)
		},
		components: {
			cropPicture
		},
		watch: {
      req: {
        deep: true,
        immediate: true,
        handler(val, old) {
          console.log(val, old, "========================>")
        }
      },
      cv: {
        deep: true,
        immediate: true,
        handler(val, old) {
          console.log(val, old, "========================>aaaaaa")
        }
      }
    },
		computed: {
			...mapState('cv', [ 'cv' ]),
			other () {
				let path = this.$route.path
				return path.includes('extras')
			},
			section () {
				return this.$route.params.type
			},
			lang () {
				return this.cv.basic_info.lang
			},
			placeHolderType () {
				let { cv_type } = this.cv.basic_info
				return cv_type && (cv_type.includes('zero') || cv_type.includes('stu')) && (this.section === 'edus' || this.eduSection)
			},
		},
		methods: {
      // 选择学校标签
      chooseTag(obj) {
        const { label, value: text } = obj
        let newTags = []
        if (this.req.show_tags.includes(text)) {
          newTags = this.req.show_tags.filter(item => item !== text)
        } else {
          newTags = [...this.req.show_tags, text]
        }
        this.req.show_tags = newTags
      },
			// 城市自动补全
			async cityAutoComplete () {
				try {
					let res = await this.$api.staticApi.cityComplete({
						keyword: this.req.city
					})
					if (res.code === 1000) {
						this.list.city = res.data
					}
				} catch (e) {
					console.log('城市自动补全 错误', e)
				}

			},
			// 大学自动补全
			async universityAutoComplete () {
				try {
					let res = await this.$api.staticApi.universityComplete({
						keyword: this.req.university
					})
					if (res.code === 1000) {
						this.list.university = res.data
					}
				} catch (e) {
					console.log('大学自动补全 错误', e)
				}
			},
			// 专业自动补全
			async majorAutoComplete () {
				try {
					let res = await this.$api.staticApi.majorComplete({
						keyword: this.req.major
					})
					if (res.code === 1000) {
						this.list.major = res.data
					}
				} catch (e) {
					console.log('专业自动补全 错误', e)
				}
			},
			// 公司名称自动补全
			async companyAutoComplete () {
				try {
					let res = await this.$api.staticApi.companyComplete({
						keyword: this.req.company
					})
					if (res.code === 1000) {
						this.list.company = res.data
					}
				} catch (e) {
					console.log('公司自动补全 错误', e)
				}
			},
			// 学院自动补全
			async uni_schoolAutoComplete () {
				try {
					let res = await this.$api.staticApi.unischoolComplete({
						keyword: this.req.uni_school
					})
					if (res.code === 1000) {
						this.list.uni_school = res.data
					}
				} catch (e) {
					console.log('学院自动补全 错误', e)
				}
			},
			// 职位名称自动补全
			async titleAutoComplete () {
				try {
					let res = await this.$api.staticApi.positionComplete({
						keyword: this.req.title
					})
					if (res.code === 1000) {
						this.list.title = res.data
					}
				} catch (e) {
					console.log('职位名称自动补全 错误', e)
				}
			},
			// 防抖
			inputChangeValue (e, item) {
				if (item.search && !e.isComposing) {
          this.req[`${ item.field }_id`] = null
          this.req[`${ item.field }_token`] = null
					this.debounce(this[`${ item.field }AutoComplete`], 300)
				}
			},
			// 选择某一个城市，专业，公司
			async selectLabel (item, val) {
        console.log(item, "===================>item")
        console.log(val, "===================>val")
				this.req[item.field] = val.name
        this.req[`${ item.field }_id`] = val.id
        this.req[`${ item.field }_token`] = val.token
				this.list[item.field] = []
        if (item.field === 'university') {
          let id = val.id
          try {
            let res = await this.$api.staticApi.getSchoolTags(id)
            console.log(res, "=================》lalal")
            if (res.code === 1000) {
              let { university_tags } = res.data
              let tagArr = ['985', '211', '双一流', '海外QS前100'], arr = [], show_tags = []
              if (this.lang === 'cn') {
                show_tags = university_tags.filter(item => tagArr.includes(item))
              } else {
                const en = {'985': '985', '211': '211', '双一流': 'Double 1st-Class', '海外QS前100': 'QS Top100'}
                university_tags.filter(item => tagArr.includes(item)).forEach(item => {
                  show_tags.push(en[item])
                })
              }
              this.req.show_tags = show_tags
            }
          } catch (e) {

          }
        }
			},
			// 点击边上
			handleClickSide ({ field }) {
				if ((this.list[field] && !this.list[field].length) || !this.list[field]) {
					for (let key in this.list) {
						this.list[key] = []
					}
				}
			},
			// 校验起止时间
			verifyModuleTime (value) {
				if (
					(this.field === 'start_at' && this.req.end_at && value > this.req.end_at) ||
					(this.field === 'end_at' && this.req.start_at && this.req.start_at > value)
				) {
					this.showToast('结束时间不能早于开始时间', 2000)
					return 'errorTime'
				}
			},
			// picker 占位符显示内容
			timeShow (val) {
				if (val.section === 'honor') {
					return this.req.present
				} else if (val.field === 'start_at') {
					return this.req.start_at
				} else if (val.field === 'end_at') {
					return this.req.end_at || this.req.present
				}
			},
			// extras修改名称
			changeLabel (label, item) {
				if (this.other) this.$emit('changeLabel', label, item)
			},
			selectExtrasLabel (item) {
				if (this.other) this.$emit('selectExtrasLabel', item)
			},
			// 点击picker 和 时间选择
			changePickerState (item) {
				this.field = item.field
				if (item.multiple) {
					this.multipleField = item.multipleField
					this.multiple = item.multiple
				}
				if (item.type === 'picker') {
					let selectedIndex = [], defaultIndex = item.pickerData[0].findIndex(v => v.value === this.req[item.field])
					selectedIndex[0] = defaultIndex > -1 ? defaultIndex : item.defaultIndex
					if (item.multiple) {
						let defaultMultipleIndex = item.pickerData[1].findIndex(v => v.value === this.req[item.multipleField])
						selectedIndex[1] = defaultMultipleIndex > -1 ? defaultMultipleIndex : item.defaultMultipleIndex
					}
					if (this.isIos) window.scrollTo(0, 0)
					const valuePicker = this.$createPicker({
						data: item.pickerData,
						selectedIndex,
						onSelect: this.valuePicker
					})
					valuePicker.show()
				} else if (item.type === 'datetime') {
					let currentYear = new Date().getFullYear(),
						currentMonth = new Date().getMonth() + 1,
						length = this.section === 'edus' || this.eduSection ? currentYear - 1950 + 5 : currentYear - 1950 + 1,
						years = Array.from({ length }, (item, index) => (index + 1950).toString()),
						currentMonths = Array.from({ length: currentMonth }, (item, i) => {
							return {
								text: i + 1 < 10 ? `0${ i + 1 }` : (i + 1).toString(),
								value: i + 1 < 10 ? `0${ i + 1 }` : (i + 1).toString()
							}
						}),
						months = Array.from({ length: 12 }, (item, i) => {
							return {
								text: i + 1 < 10 ? `0${ i + 1 }` : (i + 1).toString(),
								value: i + 1 < 10 ? `0${ i + 1 }` : (i + 1).toString()
							}
						}),
						cascadeData = [],
						selectedIndex = [ 0, 0 ]
					years.forEach(item => {
						cascadeData.push({
							value: item.toString(),
							text: item.toString(),
							children: item === currentYear.toString() && this.section !== 'edus' && !this.eduSection ? currentMonths : months
						})
					})
					if ((item.field === 'end_at' || item.field === 'present') && this.section !== 'edus' && this.section !== 'honor' && !this.eduSection) {
						if (this.lang === 'en') {
							cascadeData.push({ value: 'Present', text: 'Present', children: [] })
						} else {
							cascadeData.push({ value: '至今', text: '至今', children: [] })
						}
					}
					if ((this.req[item.field] === '至今' || this.req[item.field] === 'Present')) {
						selectedIndex = [ cascadeData.findIndex(v => v.value === this.req[item.field]) ]
					} else {
						let year = this.req[item.field] ? this.req[item.field].split('-')[0] : moment().format('YYYY')
						let month = this.req[item.field] ? this.req[item.field].split('-')[1] : moment().format('MM')
						selectedIndex[0] = years.findIndex(y => y === ((this.section === 'edus' || this.eduSection) && !this.req[item.field] ? String((item.field === 'start_at' ? year - 4 : year)) : String(year)))
						let monthDefaultValue = "09";
						if (this.sectionType === 'edus') {
							monthDefaultValue = item.field === "end_at" ? "06" : "09";
						}
						selectedIndex[1] = months.findIndex(m => m.value === ((this.section === 'edus' || this.eduSection) && !this.req[item.field] ? monthDefaultValue : String(month)))
					}
					selectedIndex[0] === -1 ? selectedIndex[0] = 0 : selectedIndex[0]

					if (
						((this.sectionType === "edus" || this.sectionType === 'other') && !this.req.start_at && item.field === "start_at") ||
						((this.sectionType === "edus" || this.sectionType === 'other') && this.req.start_at && !this.req.end_at && item.field === "end_at")
					) {
						selectedIndex = this.setEdusTimePicker(cascadeData, selectedIndex);
					}

					const cascadePicker = this.$createCascadePicker({
						data: cascadeData,
						selectedIndex,
						onSelect: this.datePicker,
					})
					cascadePicker.show()
				}
			},
			// 设置教育时间 picker
			setEdusTimePicker (cascadeData, defaultValue) {
				if (this.req.start_at && !this.req.end_at) {
					if (!!this.req.degree) {
						const year = this.req.start_at.split("-")[0];
						const year_index = cascadeData.findIndex(item => item.text === year);
						switch (this.req.degree) {
							case "本科":
								return [year_index + 4, 5];
								break;
							case "MBA":
								return [year_index + 2, 5];
								break;
							default:
								return [year_index + 3, 5];
						}
					} else {
						const current_y = new Date().getFullYear() + "";
						const current_y_index = cascadeData.findIndex(item => item.text === current_y);
						return [current_y_index, 5];
					}
				}
				return defaultValue;
			},
			// picker value改变时
			valuePicker (val) {
				if (val instanceof Array) {
					if (this.multiple) {
						this.req[this.multipleField] = val[1]
					}
					this.req[this.field] = val[0]
				}
			},
			// 选择date确定时间
			datePicker (val) {
				let value = val.filter(v => v).join('-')
				if (this.verifyModuleTime(value) === 'errorTime') {
					return
				} else {
					console.log(value,"valuevaluevalue", this.field)
					this.req[this.field] = value
					if(this.field == 'start_at'){
						this.setEduDefaultValue()
					}
				}
			},
			// 设置教育经历默认值
			setEduDefaultValue() {
				let month = "-06";
        if(this.req.end_at) {
          month = "-" + this.req.end_at.split("-")[1];
        }
        if (!this.req.start_at || !this.req.degree) {
          this.defaultEndTime = '';
        } else {
          switch (this.req.degree) {
            case "本科":
              this.defaultEndTime = +this.req.start_at.split('-')[0] + 4 + month;
              break;
            case "Bachelor":
              this.defaultEndTime = +this.req.start_at.split('-')[0] + 4 + month;
              break;
            case "MBA":
              this.defaultEndTime = +this.req.start_at.split('-')[0] + 2 + month;
              break;
            default:
              this.defaultEndTime = +this.req.start_at.split('-')[0] + 3 + month;
              break;
          }
        }
				this.req.end_at = this.defaultEndTime;
			},

			// 上传头像
			 selectQrcode() {
				this.$refs.qrcodeUpInput.click()
			},
			//获取当前选择文件
			fileChange(data) {
				let file = this.$refs.qrcodeUpInput.files[0]
				this.qrcode = file
				this.$refs.qrcodeUpInput.value = '';
				// console.log(file)
				setTimeout(() => {
					//显示裁剪
					this.showCropPicture = true
				}, 10);
			},
			//图片裁剪完回调
			qrcodeSubmit(url){
				//隐藏裁剪
				this.showCropPicture = false
				if(url){
					this.req.qrcode = ''
					this.qrcode = ''
					setTimeout(() => {
						this.req.qrcode = url
						this.qrcode = url
					}, 100);
				}else{
					this.qrcode = this.req.qrcode || ''
				}
			},
		},
		directives: {
			clickoutside
		}
	}
</script>
<style scoped lang="scss">
  @import '../../assets/scss/global/variable';
  @import '../../assets/scss/global/mixin';
  .list {
    .suggest-position {
      position: relative;
    }
    .list-item {
      background-color: $color-light;
      padding: 0 24px;
      .item-link {
        padding-top: 25px;
        padding-bottom: 12px;
        border-bottom: 1px solid #eeeff0;
        .title {
          height: 22px;
          line-height: 22px;
          font-size: $font-size-medium-x;
          color: $color-title;
        }
        .date-title {
          &:first-child::after {
            content: '';
            display: inline-block;
            width: 12px;
            height: 1px;
            background-color: $color-dark-gray;
            margin-left: 64px;
            margin-right: 56px;
          }
        }
        .honor-time-title::after {
          display: none !important;
        }
        .w-placeholder {
          color: #bcbcbc;
        }
        .label {
          display: inline-block;
          margin-bottom: 12px;
          white-space: nowrap;
          color: $color-dark-gray;
          font-size: $font-size-small;
        }
        .iconbianji {
          color: #979797;
          margin-left: 12px;
          font-size: 12px;
        }
        input {
          border: none !important;
          padding: 0;
          height: 22px;
          font-size: $font-size-medium-x;
          color: $color-title;
          width: 100%;
          &::placeholder {
            color: #bcbcbc;
            -webkit-text-fill-color: #bcbcbc;
          }
        }
        input[disabled] {
          color: $color-title;
          background-color: transparent;
          -webkit-text-fill-color: $color-title;
          -webkit-opacity: 1;
          opacity: 1;
          @include ellipsis(calc(100% - 26px));
        }
        .iconchevron-right {
          margin-left: 10px;
          color: #bcbcbc;
        }
        .search-input {
          position: relative;
          flex: 1;
        }
      }
			.qrcode-add{
				width: 108px;
				height: 108px;
				border-radius: 4px;
				border: 1px solid #ECECEC;
				text-align: center;
				line-height: 108px;
				font-size: 20px;
				color: #BCBCBC;
			}
			.qrcode-img{
				width: 110px;
				height: 110px;
				border-radius: 4px;
				overflow: hidden;
			}
    }
    .date-time-link {
      border-top: 8px solid #f5f5f5;
    }
    .honor-item {
      border-top: 0;
    }
  }
  .search-result {
    position: absolute;
    top: 26px;
    background-color: $color-light;
    width: 100%;
    height: 172px;
    border: 1px solid #eeeff0;
    border-radius: 6px;
    padding: 0 16px;
    box-sizing: border-box;
    z-index: 9;
    .search-item {
      height: 32px;
      color: $color-dark-gray;
      font-size: $font-size-medium;
      line-height: 32px;
      white-space: nowrap;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      /deep/ .es-highlighter {
        color: $color-theme;
      }
      /*width: 100%;*/
      &:first-child {
        margin-top: 6px;
      }
      &:last-child {
        margin-bottom: 6px;
      }
    }
	}
	.search-result-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: transparent;
		z-index: 8;
	}
	.up-qrcode{
		width: 0;
		height: 0;
		overflow: hidden;
		border: 0;
	}
  .tag-container {
    width: 100%;
    height: 40px;
    display: flex;
    gap: 12px;
    align-items: center;
    .tag-item {
      padding: 6px;
      border: 1px solid #4183FF;
      border-radius: 8px;
      font-weight: normal;
      color: #4183FF;
      &.active {
        border-color: #ff6644;
        background-color: #ff6644;
        color: #fff;
      }
    }
  }
</style>
